import { connect } from 'react-redux'
import { actions } from '../../store/organizationRoles'

function mapStateToProps(state) {
  return {
    authUser: state.auth,
    rolesList: state.organizationRoles.rolesList,
    capabilities: state.organizationRoles.capabilities,
    currentRole: state.organizationRoles.currentRole,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    getRolesList: (params) => dispatch(actions.getRolesList(params)),
    setRoleToEdit: (params) => dispatch(actions.setRoleToEdit(params)),
    updateRole: (params) => dispatch(actions.updateRole(params)),
    updatePermissions: (params) => dispatch(actions.updatePermissions(params)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)
